import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M11 18.17L8.41 15.59L7 17L12 22L17 17L15.59 15.59L13 18.17V2H11V18.17Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "LongDown"
);
